<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hY6KDp/tc-custom/9781418573652.jpg?1726617345278" alt="This image is the cover for the book Life's Little Instruction Book"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Life's Little Instruction Book
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The #1 <i>New York Times</i> bestseller—now in a fresh new format, offering a new generation simple yet powerful wisdom.</b></p><p>The<i></i>Life’s Little Instruction Book series has sold more than ten million copies, spent more than two years atop the <i>New York Times</i> bestseller list, and has been translated into 33 languages. Originally written from a father to a son, the book offers insights, simple suggestions, heartfelt humor, and reminders for readers of all ages. This edition offers a new trim size and on-trend design for a new generation.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        H. Jackson Brown
      </h2>
      
      <p class="authorDescription body article"><P>&#160;A New York Times best-selling author, H. Jackson Brown&rsquo;s publications are universal in appeal, with more than 30 million copies in print, available in 35 languages. His 33 books inspire readers throughout the world. He lives in Nashville, Tennessee.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cab9ef2a